import {HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthenticationService} from '../services/authentication/authentication.service';
import {catchError} from 'rxjs/operators';
import {switchMap} from 'rxjs';

export const httpAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/api/auth/v1/refresh-token')) {
    console.log('refresh token http call');
    return next(req);
  }

  const authService = inject(AuthenticationService);
  console.log('authGuard', `isAuthenticated: ${authService.isAuthenticated}`, `isTokenExpired ${authService.isTokenExpired()}`, `isRefreshTokenTime: ${authService.isRefreshTokenTime()}`, `isRefreshTokenExpired: ${authService.isRefreshTokenExpired()}`);
  if (authService.isAuthenticated && (authService.isTokenExpired() || authService.isRefreshTokenTime()) && !authService.isRefreshTokenExpired()) {
    console.log('refreshing token http');
    return authService.doRefreshToken().pipe(
      switchMap(() => {
        return handle(req, next, authService);
      }),
      catchError((err) => {
        if (err.status === 401 && !req.url.includes('/api/auth/v1/2fa/validate')) {
          authService.logout();
        }
        throw err;
      })
    )
  }

  return handle(req, next, authService);
};

function handle(req: HttpRequest<unknown>, next: HttpHandlerFn, authService: AuthenticationService) {
  console.log('calling endpoint', req.url);
  const authHeader = authService?.authorizationHeader;
  if (authHeader) {
    req = req.clone({
      setHeaders: {
        Authorization: authHeader
      },
      withCredentials: true
    });
  }
  return next(req).pipe(
    catchError((err) => {
      if (err.status === 401 && !req.url.includes('/api/auth/v1/2fa/validate')) {
        authService.logout();
      }
      throw err;
    })
  );
}
